import React from 'react';
import ReactDOM from 'react-dom';
import Toppanel from '../top_panel';

import {TreeCodex, resourceEdit} from '../../../App';

import "../../../global.js";

let headers = new Headers();
headers.append('Authorization','Bearer '+localStorage.getItem('tokenAPI'));

export class WorkAreaCodex extends React.Component {

    resourceGetNodeTypes = async () => {  
        
        //const tokenAPI = localStorage.getItem("tokenAPI");
        const uri = global.apiLink+`/api/codex/codex/nodetype-list`;
        const api_url = await 
        fetch(uri, {
            method: 'GET',
            headers:headers
        });
        const json = await api_url.json();
        if(json.status !== 200){
            alert("Не верные данные авторизации");
            localStorage.removeItem('tokenAPI');
            return false;
        }
        var NodeTypes = await json.payload;
        if(NodeTypes){
            var frit = document.getElementById("form_resource_id_template");
            frit.innerHTML = "";
            NodeTypes.array.forEach(element => {
                var newOption = document.createElement("option");
                newOption.innerHTML = element.title;
                newOption.value = element.alias;
                frit.appendChild(newOption);
            });
        }   
    }

    clearTinyEditor = (alias) => {
        var form = document.getElementById("mig_tv_"+alias);
        var inputs = form.querySelectorAll("input, textarea, selector");
        inputs.forEach((el)=>{ 
            document.getElementById(el.id).value = "";
            console.log(el.id   );
            try {
                window.tinymce.get(el.id).setContent("");
            } catch (err) {
                console.log(err);
            }
        });
        if(form.getAttribute("data-mig-el-counter") !== undefined
        && form.getAttribute("data-mig-el-counter") !== null){
            form.removeAttribute("data-mig-el-counter");
        }
    }

    formationTablePanel = (migname) =>{
            let mtp = document.getElementsByClassName("mig_table_panel");
            for(var el in mtp) {
                let MigCount = document.getElementsByClassName("mig_table_panel")[el].getAttribute("data-migcount");
                ReactDOM.render(
                    <div>
                        <button className='btn btn-primary btn-sm mr-2' name='migel-edit' onClick={(element)=>{this.formationTableMIGElEdit(element, migname, MigCount);}} data-n=''><i className='far fa-edit'></i></button>
                        <button className='btn btn-danger btn-sm' name='migel-remove' onClick={(element)=>{this.formationTableMIGElRemove(element, migname, MigCount);}} data-n=''><i className='far fa-trash-alt'></i></button>
                    </div>
                    ,
                    document.getElementsByClassName("mig_table_panel")[el]
                );
            };
    }

    formationTable = () =>{
        var mig_tv_items = document.getElementById("codex-tvlist-container").querySelectorAll(".mig_tv_item");
        var ftable = document.createElement("table");
        ftable.classList.add("table");
        ftable.classList.add("mt-2");
        ftable.classList.add("table-striped");
        ftable.classList.add("table-bordered");
        mig_tv_items.forEach( (el)=>{ 
            if(document.getElementById("codex_article_item") !== null)
            document.getElementById("codex_article_item").parentNode.removeChild(document.getElementById("codex_article_item"));
                ftable.id = el.name;
                var been = el.value.trim();
                try {
                    var outputmigel = "";
                    var jimmi = JSON.parse(been);
                    for(var prop in jimmi) {
                            outputmigel += "<tr>";
                            var jimmiprop = jimmi[prop];
                            outputmigel += "<td width='20'>"+(parseInt(prop) + 1)+"</td>";
                                for(var propvar in jimmiprop) {
                                    outputmigel += "<td>"+jimmiprop[propvar]+"</td>";
                                }
                            outputmigel += "<td width='100' data-migcount='"+prop+"' class='mig_table_panel'></td>";
                            outputmigel += "</tr>";
                    }
                    ftable.innerHTML = "<tbody>"+outputmigel+"</tbody>";
                    window.insertAfter(el, ftable);
                    this.formationTablePanel(el.name);
                } catch (err) {
                    
                }
         } );

    }

    onlineTranslit = (value) => {
        value = value.trim().replace(/\s+/g,'').toLowerCase();
        document.getElementById('form_resource_alias').value = this.cyrill_to_latin(value);
    }

    cyrill_to_latin = (text) => {

        var arrru = ['Я','я','Ю','ю','Ч','ч','Ш','ш','Щ','щ','Ж','ж','А','а','Б','б','В','в','Г','г','Д','д','Е','е','Ё','ё','З','з','И','и','Й','й','К','к','Л','л','М','м','Н','н', 'О','о','П','п','Р','р','С','с','Т','т','У','у','Ф','ф','Х','х','Ц','ц','Ы','ы','Ь','ь','Ъ','ъ','Э','э'];
        var arren = ['Ya','ya','Yu','yu','Ch','ch','Sh','sh','Sh','sh','Zh','zh','A','a','B','b','V','v','G','g','D','d','E','e','E','e','Z','z','I','i','J','j','K','k','L','l','M','m','N','n', 'O','o','P','p','R','r','S','s','T','t','U','u','F','f','H','h','C','c','Y','y','','','','','E', 'e'];
    
        for(var i=0; i<arrru.length; i++){
            var reg = new RegExp(arrru[i], "g");
            text = text.replace(reg, arren[i]);
        }

        return text;
    }

    resourceSave = async (e) => {
        e.preventDefault();
        var resourceid = document.getElementById('form-resource-create').getAttribute("data-resourceid");
        
        const tokenAPI = localStorage.getItem("tokenAPI");
        const Data = new FormData();
        let API_link = global.apiLink+`api/codex/codex/add?token=${tokenAPI}`;
        if(resourceid !== null){
            API_link = global.apiLink+`api/codex/codex/edit?token=${tokenAPI}`;
            Data.append('resourceid', resourceid);
        } 
        if(
            document.getElementById('form_resource_title').value !== document.getElementById('form_resource_title').getAttribute("data-value")
        ) Data.append('title', document.getElementById('form_resource_title').value);
        
        if(
            document.getElementById('form_resource_alias').value !== document.getElementById('form_resource_alias').getAttribute("data-value")
        ) Data.append('alias', document.getElementById('form_resource_alias').value);

        Data.append('parent_id', document.getElementById('form_resource_parentid').value);
        Data.append('active', document.getElementById('form_resource_published').value);
        Data.append('type_node', document.getElementById('form_resource_id_template').value);
        Data.append('tags', document.getElementById('form_tags').value);
            let fr_content = "";
        try {
            fr_content = window.tinymce.get('form_resource_content').getContent();
        } catch (err) {
            console.log(err);
        }
        //if(fr_content == "")fr_content = document.getElementById('form_resource_content').value;

        Data.append('content', fr_content);
        Data.append('sort', document.getElementById('form_resource_sort').value);
        
        try {
            const api_response = await 
            fetch(API_link, {
                method: 'POST',
                body: Data,
                headers:headers
            });
            if(api_response.ok){
                let api_response_var = await api_response.json();
                //this.resourceTvSave(api_response_var.payload.id);
                //document.querySelector("[name=refreshtree]").click();
                if(api_response_var.payload.id > 0) alert("Готово");
                else alert("Ошибка");
                
            } else {
                alert("Ошибка HTTP: " + api_response.status);
                //localStorage.removeItem('tokenAPI');
                return false;
            }
        } catch (error) {
            console.error('Ошибка:', error);
        }
    }
    
    render(){
        //this.resourceGetTemplates();
        this.resourceGetNodeTypes();
        var resourceid = 0;
        const Tc = new TreeCodex();
        return (
            <div id="codex-work-area" className="col-md-8 float-right">
                <div id="resource-create">
                    <form id="form-resource-create">
                        <div className="row">
                            <div className="col-md-12 text-right">
                                <button className="btn btn-primary btn-sm" onClick={this.resourceSave}>Сохранить</button>
                            </div>
                            <div className="col-md-5">
                                <div className="form-group">
                                    <label htmlFor="formGroupExampleInput">Заголовок</label>
                                    <input type="text" className="form-control" name="form_resource_title" id="form_resource_title" onChange = {() => this.onlineTranslit(document.getElementById("form_resource_title").value)} placeholder="Название ресурса" />
                                </div>
                                        <div className="form-group">
                                            <label htmlFor="formGroupExampleInput">Статус</label>
                                            <select className="custom-select" name="form_resource_published" id="form_resource_published" required>
                                            <option value="1">Опубликован</option>
                                            <option value="0">Неопубликован</option>
                                            </select>
                                        </div>
                                <div className="form-group d-none">
                                    <label htmlFor="formGroupExampleInput2">Псевдоним</label>
                                    <input type="text" className="form-control" name="form_resource_alias" id="form_resource_alias" placeholder="nazvanieresursa" />
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor="formGroupExampleInput">Родитель (<span id="parentIdShow" />)</label><br />
                                            <div id="parentEditBtn" onClick = { () => Tc.resourceEdit( document.getElementById( "form_resource_parentid" ).value ) } style={{"cursor":"pointer"}} className="btn btn-info" dangerouslySetInnerHTML={Tc.createMarkup("Редактировать")} />
                                            <input type="text" className="form-control d-none" name="form_resource_parentid" id="form_resource_parentid" placeholder="id родительского ресурса" />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="formGroupExampleInput">Тип ресурса</label>
                                            <select className="custom-select" name="form_resource_id_template" id="form_resource_id_template" required></select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="formGroupExampleInput">Сортировка</label>
                                            <input type="text" name="form_resource_sort" id="form_resource_sort" className="form-control" placeholder="500" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="form_tags">Теги</label>
                                    <div className="input-group">
                                        <div className="custom-file">
                                            <input type="text" name="form_tags" id="form_tags" className="form-control" placeholder="Теги не указаны" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="validationTextarea">Содержимое</label>
                            <textarea className="form-control richtext"  name="form_resource_content" id="form_resource_content"></textarea>
                        </div>
                    </form>
                </div>
                <div id="resource-tv-wrapper">
                    <div className="row">
                        <div id="codex-addchild-container" className="col-md-12 text-right"></div>
                        <div id="codex-tvlist-container" className="col-md-12"></div>
                    </div>
                </div>
            </div>
        );


    }
}

class Codex extends React.Component {
    render(){
        return (
            <div>
                <Toppanel title="Управление кодексами" />
                
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <TreeCodex />
                            <WorkAreaCodex />
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default Codex;